import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { 
  Outlet,
  useNavigation,
  useNavigate,
  useLocation,
  useLoaderData,
  useSearchParams,
} from "react-router-dom";

// context

// components
import LayoutApplication from '../components/layouts/application';

// reducers

export default function App() {

  // hooks
  const dispatch = useDispatch();
  const preloadeddata = useLoaderData();
  const navigation = useNavigation();
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  return (
    <LayoutApplication>
      <Outlet />
      <ToastContainer 
        position="top-right"
        autoClose={3000}
        newestOnTop={true}
        closeOnClick
        theme={'colored'}
      />
    </LayoutApplication>
  );
}

